export default {
  title_one: '🥳 {{offer}} appliquée',
  title_other: '🥳 {{count}} offres appliquées',
};
